import React, { useMemo } from 'react'
import { ThemeProvider } from 'styled-components'

import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  NoSsr
} from '@mui/material'

// const appState = {
//   dark: false,
//   toggleDark: () => {},
// }

// export const AppContext = createContext(appState)

export const MasterThemeProvider = ({ children }) => {
  // const [dark, setDark] = useState(false)

  // Toggle function
  // const toggleDark = () => setDark(!dark)

  const theme = useMemo(() => createTheme({
    palette: {
      primary: {
        main: '#36503C', // Dark green
        light: '#6084BB', // Lighter blue
        dark: '#22363D', // Darker blue
        contrastText: '#FFFFFF', // White for contrast
      },
      secondary: {
        main: '#A697A9', // Light purple
        light: '#C2BECE', // Even lighter purple
        dark: '#7A7A7A', // Dark gray for contrast
        contrastText: '#000000', // Black for contrast
      },
      error: {
        main: '#E84855', // A bright red shade
        light: '#F4989C', // A lighter red
        dark: '#A62A3C', // A darker red
        contrastText: '#FFFFFF', // White for contrast
      },
      warning: {
        main: '#F9DC5C', // A bright yellow shade
        light: '#FFF7B0', // A lighter yellow
        dark: '#D4AF37', // A darker yellow
        contrastText: '#000000', // Black for contrast
      },
      info: {
        main: '#6084BB', // Bright blue shade
        light: '#85C1E9', // A lighter blue
        dark: '#2C62A4', // A darker blue
        contrastText: '#FFFFFF', // White for contrast
      },
      success: {
        main: '#50C878', // A bright green shade
        light: '#8CD9A3', // A lighter green
        dark: '#3A8B56', // A darker green
        contrastText: '#FFFFFF', // White for contrast
      },
      background: {
        default: '#F4F4F2', // Light grey background
        dark: '#1E1E1E', // Dark background for dark mode
      }
    },
    typography: {
      fontFamily: [
        "Roboto",
        "Helvetica",
        "Arial",
        "sans-serif"
      ].join(','),
      fontSize: 12,
    },
  }), []);
  // remember to add dark as dependency

  return(
  <NoSsr>
    {/* <AppContext.Provider value={{ dark, toggleDark }}> */}
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          {children}
        </ThemeProvider>
      </MuiThemeProvider>
    {/* </AppContext.Provider> */}
  </NoSsr>
)}